export const FUEL_AXIS_MIN = 0
export const FUEL_AXIS_MAX = 100

export const LOW_FUEL_PERCENT = 15
export const REFUEL_DELTA_PERCENT = 5

export const FUEL_COLOR = '#0284c7'
export const FUEL_AREA_COLOR = 'rgba(2, 132, 199, 0.18)'
export const LOW_FUEL_COLOR = '#dc2626'
export const REFUEL_COLOR = '#16a34a'

export const CANVAS_TOP = 24
export const CANVAS_LEFT = 64
export const CANVAS_RIGHT = 30

export const DEFAULT_CHART_HEIGHT = 440
export const MIN_CHART_CANVAS_PX = 180

export const SAMPLE_LIMIT = 10000
